/**
 * @generated SignedSource<<ae0dec70d377b6ae198839070dcfd00c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFeedPostCreateMutation_brand$data = {
  readonly id: string;
  readonly " $fragmentType": "useFeedPostCreateMutation_brand";
};
export type useFeedPostCreateMutation_brand$key = {
  readonly " $data"?: useFeedPostCreateMutation_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFeedPostCreateMutation_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFeedPostCreateMutation_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "74afb5a856d356cdebb5fc7a3a207f94";

export default node;
